import { render } from "./PlayoutLimitDetailModal.vue?vue&type=template&id=0bf903c0"
import script from "./PlayoutLimitDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutLimitDetailModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutLimitDetailModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bf903c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bf903c0', __exports__)) {
    api.reload('0bf903c0', __exports__)
  }
  
  module.hot.accept("./PlayoutLimitDetailModal.vue?vue&type=template&id=0bf903c0", () => {
    api.rerender('0bf903c0', render)
  })

}


export default __exports__